module.exports = __webpack_public_path__ + "static/media/Decisions_Step1_Image17.aed2182f.webp";